import { render } from "./CreateQuestion.vue?vue&type=template&id=3b2a440c&scoped=true"
import script from "./CreateQuestion.vue?vue&type=script&lang=js"
export * from "./CreateQuestion.vue?vue&type=script&lang=js"

import "./CreateQuestion.vue?vue&type=style&index=0&id=3b2a440c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2a440c"]])

export default __exports__